import React, {Fragment} from "react";
import {Card, CardBody, Form, Input} from "reactstrap";
import SFXButtonComponent from "../../../components/SFXButtonComponent";
import {withRouter} from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import ContactUsService from "../../../services/ContactUsService";
import ToastHelper from "../../../utils/ToastHelper";

class InboundTransactionSearchContactUs extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            name: "",
            email: "",
            phone: "",
            subject: "",
            tellUsMore: "",
            showingRecaptcha: true,
            recaptchaData: undefined
        }

    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    onSubmit(event) {
        if(event){
            event.preventDefault();
        }
        let state = this.state;
        let contactUsRequest = {};
        contactUsRequest["name"] = state.name;
        contactUsRequest["emailAddress"] = state.email;
        contactUsRequest["subject"] = state.subject;
        contactUsRequest["messageBody"] = state.tellUsMore;
        contactUsRequest["issue"] = this.props.transactingPartnerConfig["REMITTANCE_PARTNER_DISPLAY_VALUE"];
        contactUsRequest["cellphoneNumber"] = state.phone;
        contactUsRequest["response"] = state.recaptchaData;
        contactUsRequest["remoteIp"] = "";

        //TODO:Confirm messages with Bradley
        ContactUsService.submitRequest(contactUsRequest).then(response => {
            if(response["errors"]){
                ToastHelper.formatError("There was an issue sending the email. Please try again.");
            }
            else {
                ToastHelper.success("Email successfully sent");
                this.setState({
                    name: "",
                    email: "",
                    phone: "",
                    subject: "",
                    tellUsMore: "",
                    showingRecaptcha: true,
                    recaptchaData: undefined
                }, this.props.onBackClick);
            }
        });
    }

    isSubmitDisabled() {
        return this.state.name === "" || this.state.email === "" || this.state.phone === "" || this.state.subject === "" || this.state.tellUsMore === ""
    }

    onRecaptchaClick(e){
        this.setState({
            recaptchaData: e,
            showingRecaptcha: false
        });
    }

    render() {
        return <Fragment>
            {this.renderCard(this.props.isMobile ? "mobile" : "browser")}
        </Fragment>
    }

    renderCard(className) {
        return <Fragment>
            <Card className={"card-contact-us"}>
                <CardBody>
                    <Form>
                        <Input type="text" name="name" placeholder={"Name"} className={"form-input"}
                               onChange={this.handleInputChange.bind(this)}/>
                        <Input type="text" name="email" placeholder={"Email"} className={"form-input"}
                               onChange={this.handleInputChange.bind(this)}/>
                        <Input type="text" name="phone" placeholder={"Phone"} className={"form-input"}
                               onChange={this.handleInputChange.bind(this)}/>
                        <Input type="text" name="subject" placeholder={"Subject"} className={"form-input"}
                               onChange={this.handleInputChange.bind(this)}/>
                        <Input type="textarea" name="tellUsMore" placeholder={"Tell us more"}
                               className={"form-input"} onChange={this.handleInputChange.bind(this)}/>
                        {!this.state.showingRecaptcha ?
                            <div className={"contact-us-submit-button-container"}>
                                <SFXButtonComponent onClick={this.onSubmit.bind(this)}
                                                    disabled={this.isSubmitDisabled()}
                                                    className={className + "_register_button search-button"}>Submit</SFXButtonComponent>
                            </div>
                            :
                            <div className="App recaptcha-container">
                                <ReCAPTCHA
                                    sitekey="6LfdvtcUAAAAAM0uXO3x786j-T0mkpWWkPM-waXk"
                                    onChange={this.onRecaptchaClick.bind(this)}
                                />
                            </div>
                        }
                    </Form>
                </CardBody>
            </Card>
            <SFXButtonComponent onClick={this.props.onBackClick} className={"back-arrow-contact-us"}><i
                className={"fa fa-arrow-left"}/></SFXButtonComponent>
        </Fragment>
    }
}

export default withRouter(InboundTransactionSearchContactUs)